module.exports = __webpack_public_path__ + "img/security-4-image.52a2afca.jpg";